import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useWindowSize } from '@uidotdev/usehooks'
import { clsx } from 'clsx'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'
import { AnimatePresence, motion } from 'framer-motion'
import SelectAic from '../../shared/components/selectAic'
const MAX_MOBIL_DEVICES = 869

export const MobileMenu = (props) => {
  const { options, selectedOption, setSelectedOption } = props
  const selectOptions = useMemo(
    () => options.map((item) => ({ value: item?.id, label: item?.title })),
    [options],
  )
  const defaultOption = useMemo(
    () => selectOptions.find((x) => x.value === selectedOption),
    [options, selectedOption],
  )
  const textStyle = `!text-eerie-black-dark !text-[20px] !font-[400] font-halyard`
  const paddingInputs = `
  px-[15px] py-[15px] leading-normal
  `
  const customStyles = {
    control: () => {
      return clsx(`${paddingInputs}
        !rounded-[37px] !border !border-[1px] !border-eerie-black
        md:w-full !bg-isabelline
        hover:!border-eerie-black-dark
         `)
    },
    singleValue: () => clsx(`${textStyle}`),
    placeholder: () => `${textStyle}`,
    indicatorSeparator: () => '!hidden',
    dropdownIndicator: () => '!text-eerie-black-dark !font-[400]',
    listBox: () => `!rounded-[20px] !p-0 !m-0`,
    menu: () => `!rounded-[20px] !text-[20px]`,
    menuList: () => `!rounded-[20px] !p-0 !m-0`,
    option: (state) => {
      return clsx(
        state.isSelected ? `!bg-force-blue text-white` : `hover:bg-eerie-black hover:text-white`,
      )
    },
  }
  return (
    <div className="mobile-menu">
      <InViewSimpleTransition type={'fade'} parent={null} slide_direction={'right'}>
        <SelectAic
          value={defaultOption}
          onChange={(value) => {
            setSelectedOption(value?.value)
          }}
          className=""
          options={selectOptions}
          classNames={customStyles}
        />
      </InViewSimpleTransition>
    </div>
  )
}

export const DesktopMenu = (props) => {
  const { options, currentBrand, selectNewCurrentBrand } = props
  // const scope = useMenuAnimation(options);
  return (
    <div className="brand-menu">
      <h2>Brands: </h2>
      <AnimatePresence>
        <ul exit="exit" className="brand-names">
          {options.map((brand, index) => (
            <motion.li
              className={currentBrand === brand.id ? 'selected' : ''}
              viewport={{ amount: 0.1, once: true }}
              initial={{
                x: 30,
                opacity: 0,
              }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  duration: index > 0 ? index * 0.3 : 0.5,
                  ease: 'easeInOut',
                },
              }}
              key={index}
              onClick={() => selectNewCurrentBrand(brand.id)}
            >
              {brand.title}
            </motion.li>
          ))}
        </ul>
      </AnimatePresence>
    </div>
  )
}

export const BrandHotelsMenu = (props) => {
  const { options, currentBrand, selectNewCurrentBrand } = props
  const { width } = useWindowSize()
  const [usingMovilScreen, setusingMovilScreen] = useState(width <= MAX_MOBIL_DEVICES)

  const updateScreenWidth = (_width) => {
    setusingMovilScreen(_width <= MAX_MOBIL_DEVICES)
  }
  useEffect(() => {
    updateScreenWidth(width)
  }, [width])

  return usingMovilScreen ? (
    <MobileMenu
      options={options}
      selectedOption={currentBrand}
      setSelectedOption={selectNewCurrentBrand}
    />
  ) : (
    <DesktopMenu
      options={options}
      currentBrand={currentBrand}
      selectNewCurrentBrand={selectNewCurrentBrand}
    />
  )
}

MobileMenu.propTypes = {
  options: PropTypes.array,
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func,
}

DesktopMenu.propTypes = {
  options: PropTypes.array,
  currentBrand: PropTypes.string,
  selectNewCurrentBrand: PropTypes.func,
}
BrandHotelsMenu.propTypes = {
  options: PropTypes.array,
  currentBrand: PropTypes.string,
  selectNewCurrentBrand: PropTypes.func,
}
